import type { FaireProductEntity } from "../../entity_types/product";

export const p_k7r3rtr8vh: FaireProductEntity = {
  token: "p_k7r3rtr8vh",
  type: "product",
  name: "12oz Boylan Grape Cane Sugar Soda Glass Bottled Beverage",
  brandToken: "b_7b25cuen6n",
  brandName: "EcoQuality",
  imageUrl:
    "https://cdn.faire.com/fastly/08ea1712d9be5bed1c1a96787627fd79303e98687942d2c2e6e9ceacbb5e58c4.png",
  galleryImageUrls: [],
  priceDollars: 85.6,
  description:
    "12oz Boylan Grape Cane Sugar Soda Glass Bottled Beverage\n\nEnjoy the bold, fruity flavor of Boylan Grape Soda in a premium 12oz clear glass bottle crafted for classic refreshment. This craft soda delivers rich grape taste with lively carbonation and a smooth finish, making it ideal for specialty retail, restaurants, parties, and nostalgic soda lovers. The durable glass bottle enhances shelf appeal, preserves freshness and fizz, and provides a recyclable packaging solution for premium single serve beverage service.\n\nFeatures:\n12oz single serve bottle for portion control\nMade with pure cane sugar for natural sweetness\nBold and refreshing grape flavor\nGreat for parties, events, or daily enjoyment\nClear glass bottle for premium presentation\nFull case includes 24 pieces",
  tags: [],
  msrpDollars: 107,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:45.148Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
